@if (products) {
  @if (!isSingleView) {
    <span class="search-title" translate>Products</span>
  }
  @if (isSingleView) {
    <span class="search-title" translate>Best Matches</span>
  }
  <div class="products-list" [ngClass]="{ 'single-view': isSingleView }">
    @if (products.length) {
      @for (product of products; track product) {
        <div
          class="product-list__item"
          [ngClass]="{
            hovered: isSingleView && hoveredProduct && hoveredProduct.sku === product.sku,
          }"
          (mouseenter)="hoverProduct(product)"
        >
          <div class="product-left-info">
            <a
              class="img-wrap"
              (click)="toggleAutocomplete.emit()"
              [sRouterLink]="[
                'product',
                product.type_id === ProductType.Bundle
                  ? product.url_key[0]
                  : product.url_key,
              ]"
              title="{{
                product.type_id === ProductType.Bundle ? product.name[0] : product.name
              }}"
            >
              <img loading="lazy" [src]="product.image_small" [alt]="product.name" />
            </a>
            <div class="product-name">
              <a
                (click)="toggleAutocomplete.emit()"
                [sRouterLink]="[
                  'product',
                  product.type_id === ProductType.Bundle
                    ? product.url_key[0]
                    : product.url_key,
                ]"
                title="{{
                  product.type_id === ProductType.Bundle ? product.name[0] : product.name
                }}"
                class="product-title"
              >
                {{
                  product.type_id === ProductType.Bundle
                    ? product.name[0]
                    : (product.name | translate | async)
                }}
              </a>
              <span class="product-desc">
                {{ 'Product code' | translate | async }}: {{ product.sku }}
              </span>
            </div>
          </div>
          <div class="product-price">
            <app-currency></app-currency>
            <app-price [price]="product.finalPrice"></app-price>
          </div>
        </div>
      }
    } @else {
      <div class="empty-template">
        <span class="empty-template__title" translate>Uuupppss :(</span>
        <span class="empty-template__text" translate>No results found!</span>
      </div>
    }
  </div>
}
